import "./index.css";
import React, { useCallback, useEffect } from "react";
import OrderSortSelect from "./OrderSortSelect";
import ShopDTO from "@/dto/shop/ShopDTO";
import OrderTab from "@/scenes/OrderManagement/enum/OrderTab";
import AdditionalColumnsSelect from "./AdditionalColumnsSelect";
import { useAddressDeliverableStore } from "@/scenes/OrderManagement/store/AddressDeliverableStore";
import { Button } from "antd";
import { observer } from "mobx-react-lite";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import ShopType from "@/enum/ShopType";
import ProductFilter from "./ProductFilter";
import ShopAdvancedSettingButton from "./ShopAdvancedSettingButton";

interface ListOptionsPaneProps {
    shop?: ShopDTO;

    tab?: OrderTab;
}

// TODO 不同平台的付款时间有不同的名称，比如有些平台是 成团时间
// TODO 商品显示可以让用户自由多选
const ListOptionsPane: React.FC<ListOptionsPaneProps> = function (props) {
    const { shop, tab } = props;
    const orderManagementStore = useOrderManagementStore();

    const shopId = shop?.id;

    const handleAddressReachableCheckButtonClick = useCallback(() => {
        const bol = !orderManagementStore.table.showAddressReachableCheckPane;

        orderManagementStore.table.switchShowAddressReachableCheckPane(bol);
    }, []);

    const { clearAddressDeliverableCheckResults } = useAddressDeliverableStore();

    useEffect(() => {
        clearAddressDeliverableCheckResults();

        orderManagementStore.table.switchShowAddressReachableCheckPane(false);
    }, [shop.id, tab]);

    return (
        <div className="list-options-pane">
            <div className="row">
                <div className="left col">
                    {![OrderTab.LOGISTICS_WARNING, OrderTab.PICKUP_DEADLINE_WARNING].includes(tab) && (
                        <div className="pr">
                            <span className="mr10" style={{ fontSize: 12 }}>
                                排序:
                            </span>
                            <OrderSortSelect shop={shop} tab={tab} />
                        </div>
                    )}

                    <Button size="small" className=" ml5" onClick={handleAddressReachableCheckButtonClick}>
                        {orderManagementStore.table.showAddressReachableCheckPane ? "隐藏" : "显示"}快递派送范围检测
                    </Button>
                </div>

                <div className="right ">
                    <AdditionalColumnsSelect shop={shop} tab={tab} />

                    <ShopAdvancedSettingButton shopId={shopId} />

                    {![ShopType.MANUAL, ShopType.INDEPENDENT_MANUAL].includes(shop.type) &&
                        [OrderTab.PENDING_SHIPMENT, OrderTab.ON_HOLD, OrderTab.SHIPPED].includes(tab) && (
                            <ProductFilter className="ml5" tab={tab} />
                        )}
                </div>
            </div>
        </div>
    );
};

export default observer(ListOptionsPane);
